import {ROLES} from 'constants/enum/userRoles'
import {USER_STATUSES} from 'constants/enum/userStatuses'
import ZodConfig from 'constants/zodConfig'
import {z} from 'zod'

const firstName = {
    name: 'firstName',
    rules: {required: true},
    sm: 6,
    xs: 6,
}

const lastName = {
    name: 'lastName',
    rules: {required: true},
    sm: 6,
    xs: 6,
}

const email = {
    name: 'email',
    rules: {required: true},
    sm: 6,
    xs: 6,
}

const phone = {
    name: 'phone',
    rules: {required: true},
    sm: 6,
    xs: 6,
}

const role = {
    name: 'role',
    type: 'select',
    label: 'role',
    options: ROLES,
    withTranslation: true,
    rules: {required: true},
    sm: 6,
    xs: 12,
}
const password = {
    name: 'password',
    rules: {required: true},
    sm: 6,
    xs: 6,
}
const confirmPassword = {
    name: 'confirmPassword',
    rules: {required: true},
    sm: 6,
    xs: 6,
}

const status = {
    name: 'status',
    type: 'switch',
    label: 'status',
    options: USER_STATUSES,
    withTranslation: true,
    rules: {required: true},
    sm: 6,
    xs: 6,
}

const userAccounts = {
    confirmed: {
        name: 'confirmed',
        type: 'switch',
        label: 'confirmed',
        rules: {required: true},
        sm: 12,
        xs: 12,
    },
    account: {
        name: 'account',
        type: 'autocomplete',
        label: 'account',
        rules: {required: true},
        sm: 6,
        xs: 12,
        readOnly: true,
    },
    role: {
        name: 'role',
        type: 'select',
        label: 'role',
        options: ROLES,
        withTranslation: true,
        rules: {required: true},
        sm: 6,
        xs: 12,
    },
}
export const createUserField = {
    createUser: {
        title: 'createUser',
        items: {firstName, lastName, email, phone, role},
    },

    password: {
        title: 'password',
        items: {password, confirmPassword},
    },
}

export const editUserField = {
    editUser: {
        title: 'editUser',
        items: {firstName, lastName, email, phone, role, status},
    },
    userAccounts: {
        title: 'userAccounts',
        type: 'array',
        withButtons: false,
        appendOnEmpty: false,
        arrayName: 'userAccounts',
        items: {...userAccounts},
    },
}

export const createUserFieldValidation = z.object({
    firstName: ZodConfig.string(),
    lastName: ZodConfig.string(),
    email: ZodConfig.string().email({message: 'email'}),
    phone: ZodConfig.string().min(6, {message: 'phone'}),
    role: ZodConfig.enum(ROLES),
    password: ZodConfig.string().min(6, {message: 'password'}),
    confirmPassword: ZodConfig.string().min(6, {message: 'confirmPassword'}),
})

export const editUserFieldValidation = z.object({
    firstName: ZodConfig.string(),
    lastName: ZodConfig.string(),
    email: ZodConfig.string().email({message: 'email'}),
    phone: ZodConfig.string().min(6, {message: 'phone'}),
    role: ZodConfig.enum(ROLES),
    status: ZodConfig.enum(USER_STATUSES),
})
